import React, { PropsWithChildren } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";

type AssignModalShellProps = PropsWithChildren<{
    show: boolean;
    onHide: () => void;
    title: React.ReactNode;
    saving?: boolean;
    saveDisabled?: boolean;
    onSave: () => void;
    onCancel?: () => void;
    testId?: string;
    cancelTestId?: string;
    saveTestId?: string;
}>;

const AssignModalShell: React.FC<AssignModalShellProps> = ({
    show,
    onHide,
    title,
    children,
    saving = false,
    saveDisabled = false,
    onSave,
    onCancel,
    testId,
    cancelTestId,
    saveTestId,
}) => {
    const handleCancel = onCancel ?? onHide;

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            backdrop="static"
            size="lg"
            data-testid={testId}
        >
            <Modal.Header closeButton className="border-0 pb-0">
                <Modal.Title className="d-flex align-items-center gap-2 fw-semibold">
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body
                className="pt-3"
                style={{ maxHeight: "70vh", overflowY: "auto" }}
            >
                {children}
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="outline-secondary"
                    onClick={handleCancel}
                    disabled={saving}
                    data-testid={cancelTestId}
                >
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    size="lg"
                    className="btn-action"
                    onClick={onSave}
                    disabled={saving || saveDisabled}
                    aria-busy={saving}
                    data-testid={saveTestId}
                >
                    {saving ? (
                        <>
                            <Spinner size="sm" animation="border" className="me-2" />
                            Saving...
                        </>
                    ) : (
                        "Save"
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default AssignModalShell;
